import Vue from 'vue'
import Vuex from 'vuex'
import { http } from '@/service/http'
import { setLocal, getLocal, b64EncodeUnicode } from '@/utils/tool'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    parkData: getLocal('parkData') || {},
    agencyList: getLocal('agencyList') || [],
    curAgency: getLocal('curAgency') || {},
    upToken: getLocal('upToken') || {},
    class: getLocal('class') || []
  },
  mutations: {
    changeParkData: (state, data) => {
      state.parkData = data
    },
    changeAgencyLsit: (state, data) => {
      state.agencyList = data
    },
    changeCurAgency: (state, data) => {
      state.curAgency = { ...data }
    },
    changeUpToken: (state, data) => {
      state.upToken = data
    },
    changeClass: (state, data) => {
      state.class = data
    }
  },
  actions: {
    getParkData({ commit, state }, params) {
      // http.parkData().then(res => {
      //   commit('changeParkData', res.data)
      //   setLocal('parkData', res.data)
      // })
      http.getParkJson().then(res => {
        commit('changeParkData', res.data)
        setLocal('parkData', res.data)
      })
    },
    getAgencyList({ commit, state }, params) {
      // http.agencyData().then(res => {
      //   commit('changeAgencyLsit', res.data.list || [])
      //   commit('changeCurAgency', (res.data.list || []).length ? res.data.list[0] : {})
      //   setLocal('agencyList', res.data.list || [])
      //   setLocal('curAgency', (res.data.list || []).length ? res.data.list[0] : {})
      // })
      http.getAgencyJson().then(res => {
        commit('changeAgencyLsit', res.data.list || [])
        commit('changeCurAgency', (res.data.list || []).length ? res.data.list[0] : {})
        setLocal('agencyList', res.data.list || [])
        setLocal('curAgency', (res.data.list || []).length ? res.data.list[0] : {})
      })
    },
    login({ commit, state }) {
      const user = 'W08xRrzoCxI0oYvr5rNLSkZ4'
      const password = '1immildBreVfh7SoCJadYohkrsquUPeJKkdcEIVugOUZTyT6'
      // const user = 'UxqnIYG5vi6z3fmcidWb8Dk0'
      // const password = 'oWho8TqAhDLVInkNvGuHPyeQAo9tIUlkKmvcAofrr1PtWMKz'
      const basic = `Basic ` + b64EncodeUnicode(`${user}:${password}`)
      http.login({
        'grant_type': 'password',
        'username': 'admin',
        'password': '123456',
        'scope': 'upload_file'
      }, true, {
        headers: {
          'Authorization': basic
        }
      }).then(res => {
        setLocal('upToken', res)
        commit('changeUpToken', res || {})
      })
    },
    getClass({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        http.getClass({ parent_id: id }).then(res => {
          (res.data.data || []).forEach(item => {
            item.level = 2
            item.id = item.id.toString()
            item.child.forEach(ite => {
              ite.level = 3
              ite.id = ite.id.toString()
              ite.child.forEach(it => {
                it.level = 4
                it.id = it.id.toString()
                if (it.child.length === 0) {
                  delete it.child
                }
              })
              if (ite.child.length === 0) {
                delete ite.child
              }
            })
            if (item.child.length === 0) {
              delete item.child
            }
          })
          commit('changeClass', res.data.data || [])
          resolve(res.data.data || [])
        })
      })
    }
  },
  getters: {
    areaInfo: state => state.parkData.areaInfo || { data: [] },
    pillarInfo: state => state.parkData.pillarInfo || { data: {}},
    energyConsumptionInfo: state => state.parkData.energyConsumptionInfo || { data: [] },
    energyConsumptionData: state => (state.parkData.energyConsumptionInfo || { data: [] }).data,
    unitEnergyConsumption: state => state.parkData.unitEnergyConsumption || { data: [] },
    dateEnergyConsumption: state => state.parkData.dateEnergyConsumption || { data: {}}
  }
})
